<template>
  <div class="home-wrapper">
    <Navbar />
    <div class="content">
      <router-view />
    </div>
    <div class="footer">
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import Navbar from '../components/Navbar'

export default {
  name: 'Home',
  components: {
    Navbar
  }
}
</script>

<style scoped lang="scss">
  @import "../vars";

  .home-wrapper {
    color: $tc;
    height: 100%;
    .content {
      height: calc(100% - (#{$navbar-height} * 2));
      overflow: auto;
      scroll-behavior: smooth;
      display: flex;
      flex-direction: column;
    }
    .footer {
      height: $navbar-height;
      background-color: #464646;
      position: relative;
    }
  }

  @media screen and (max-width: 550px){
    .home-wrapper {
      .content {
        height: calc(100% - #{$navbar-height});
      }
      .footer {
        display: none;
      }
    }
  }
</style>
